import '/usr/local/cedar/client/node_modules/@storybook/addon-interactions/dist/manager.mjs';